import { render } from "./KYCVerification.vue?vue&type=template&id=1e5e236c&scoped=true"
import script from "./KYCVerification.vue?vue&type=script&lang=js"
export * from "./KYCVerification.vue?vue&type=script&lang=js"

import "./KYCVerification.vue?vue&type=style&index=0&id=1e5e236c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5e236c"]])

export default __exports__